import SocketController from './Socket';

class ChatSocketController extends SocketController {}

export default new ChatSocketController();
